class WistiaHelper {
    static appendWistiaVideo($target, wistiaId, playerColor, endVideoBehavior, isModal = true, autoPlay = true) {
        this.renderVideo($target, wistiaId, playerColor, endVideoBehavior, autoPlay);
    }

    /**
     * Paste wistia video in to the DOM
     * @param {jQuery} $target - where to append video frame
     * @param {string} wistiaId - video id
     * @param {string} playerColor - color for player control panel
     * @param {string} endVideoBehavior - https://wistia.com/doc/embed-options#endvideobehavior
     */
    static renderVideo($target, wistiaId, playerColor, endVideoBehavior, autoPlay) {
        this.getScriptWistia();

        $target.append(
            '' +
                '<div class="wistia_responsive_padding">' +
                '<div class="wistia_responsive_wrapper">' +
                '<div class="wistia_embed wistia_async_' +
                wistiaId +
                ' autoPlay=' +
                autoPlay +
                ' playerColor=' +
                playerColor +
                ' endVideoBehavior=' +
                endVideoBehavior +
                '">&nbsp;</div>' +
                '</div>' +
                '</div>'
        );
    }

    static getScriptWistia(videoInstance, callback) {
        if (typeof window.Wistia === 'undefined') {
            $.getScript('https://fast.wistia.com/assets/external/E-v1.js').done((script, textStatus) => {
                if (typeof callback === 'function') {
                    callback(videoInstance);
                }
            });
        } else {
            if (typeof callback === 'function') {
                callback(videoInstance);
            }
        }
    }
}

export default WistiaHelper;



// WEBPACK FOOTER //
// ./assets/js/common/gdpr/wistia-helper.js